import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=331387b8&scoped=true"
import script from "./BillingList.vue?vue&type=script&lang=js"
export * from "./BillingList.vue?vue&type=script&lang=js"
import style0 from "./BillingList.vue?vue&type=style&index=0&id=331387b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331387b8",
  null
  
)

export default component.exports